<template>
  <div class="info-up-box">
    <div class="text1 fw600 mb30 flex flex-between">
      <div>
        {{ showIndex === 1 ? "报名信息" : "资料上传" }}
      </div>
      <div @click="$router.push({ name: 'educationalBrand' })">
        <img
          style="width: 30px; height: 30px; cursor: pointer"
          src="@/assets/images/img59.png"
          alt=""
          title="返回"
        />
      </div>
    </div>
    <step-view :showIndex="showIndex"></step-view>
    <div v-if="showIndex === 1">
      <step1
        ref="step1"
        @goStep="goStep"
        :editInfoStep1="editInfoStep1"
      ></step1>
    </div>
    <div v-if="showIndex === 2">
      <step2
        :loadList="loadList1"
        :oldApplyFiles1="oldApplyFiles1"
        @downStep="downStep"
        @upStep="upStep"
        @deleteFile="deleteFile"
        @upDataFile="upDataFile"
      ></step2>
    </div>
    <div v-if="showIndex === 3">
      <!-- @upStep2="upStep2" -->
      <a-spin :spinning="spinning">
        <step3
          ref="step3"
          :loadList="loadList2"
          :oldApplyFiles2="oldApplyFiles2"
          @deleteFile2="deleteFile2"
          @submit="submit"
          @upStep2="upStep2"
          @downStep2="downStep2"
          @upDataFile="upDataFile"
        ></step3>
      </a-spin>
    </div>
    <div v-if="showIndex === 4">
      <!-- @upStep2="upStep2" -->
      <a-spin :spinning="spinning">
        <step4
          ref="step4"
          :loadList="loadList3"
          :oldApplyFiles3="oldApplyFiles3"
          @deleteFile3="deleteFile3"
          @submit="submit"
          @upStep3="upStep3"
          @downStep3="downStep3"
          @upDataFile="upDataFile"
        ></step4>
      </a-spin>
    </div>
    <div v-if="showIndex === 5">
      <!-- @upStep2="upStep2" -->
      <a-spin :spinning="spinning">
        <step5
          ref="step5"
          :loadList="loadList4"
          :oldApplyFiles4="oldApplyFiles4"
          @deleteFile4="deleteFile4"
          @submit="submit"
          @upStep4="upStep4"
          @upDataFile="upDataFile"
        ></step5>
      </a-spin>
    </div>
  </div>
</template>

<script>
import stepView from "./stepView.vue";
import step1 from "./step1.vue";
import step2 from "./step2.vue";
import step3 from "./step3.vue";
import step4 from "./step4.vue";
import step5 from "./step5.vue";
import { lxApplySaveOrUpdate, deleteFile } from "@/api/index";
import { pieviewURL } from "@/utils/request";
export default {
  name: "",
  components: { stepView, step1, step2, step3, step4, step5 },
  props: {
    editInfo: { type: Object, default: null },
  },
  data() {
    return {
      showIndex: 1,
      step1: null,
      step2: {},
      step3: {},
      step4: {},
      step5: {},
      spinning:false,
      oldApplyFiles1: [],
      oldApplyFiles2: [],
      oldApplyFiles3: [],
      oldApplyFiles4: [],
      loadList1: [
        {
          title: "名班主任工作室建设方案",
          id: 7,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100M",
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "名班主任工作室实录视频",
          id: 8,
          remarks: "注：时长4-5分钟，分辨率不低于720p，视频大小不超过400M,格式为MP4格式",
          accept: ".MP4",
          icon: require("../../assets/images/img30.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        // {
        //   title: "专项资金经费支持相关文件上传",
        //   id: 3,
        //   remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
        //   accept: ".pdf",
        //   icon: require("../../assets/images/img31.png"),
        //   fileList: [],
        //   oldFileList: [],
        //   loading: false,
        // },
      ],
      loadList2: [
        {
          title: "班级建设方案",
          id: 1,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "典型工作案例",
          id: 2,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img30.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "主题班会方案1",
          id: 3,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img31.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "主题班会方案2",
          id: 4,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img31.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "班会实录视频",
          id: 5,
          remarks: "注：时长40分钟以内，分辨率不低于720p，视频大小不超过400M,格式为MP4格式",
          accept: ".mp4",
          icon: require("../../assets/images/img28.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "专业人才培养方案",
          id: 6,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img30.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
      ],
      loadList3: [
        {
          title: "班级建设方案",
          id: 9,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "典型工作案例",
          id: 10,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img30.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "主题班会方案1",
          id: 11,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img31.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "主题班会方案2",
          id: 12,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img31.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "班会实录视频",
          id: 13,
          remarks: "注：时长40分钟以内，分辨率不低于720p，视频大小不超过400M,格式为MP4格式",
          accept: ".mp4",
          icon: require("../../assets/images/img28.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "专业人才培养方案",
          id: 14,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img30.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
      ],
      loadList4: [
        {
          title: "班级建设方案",
          id: 15,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "典型工作案例",
          id: 16,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img30.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "主题班会方案1",
          id: 17,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img31.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "主题班会方案2",
          id: 18,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img31.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "班会实录视频",
          id: 19,
          remarks: "注：时长40分钟以内，分辨率不低于720p，视频大小不超过400M,格式为MP4格式",
          accept: ".mp4",
          icon: require("../../assets/images/img28.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "专业人才培养方案",
          id: 20,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img30.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
      ],
      teacher1:"",
      teacher2:"",
      phone1:"",
      phone2:"",
      teacher3:"",
      phone3:"",
      editInfoStep1: {},
      id: null,
    };
  },
  computed: {},
  watch: {},
  created() {},
  destroyed() {
    window.sessionStorage.removeItem(`step${this.$store.state.user.id}`);
  },
  mounted() {
    if (this.editInfo !== null) {
      // console.log(this.editInfo,'编辑组件')
      this.id = this.editInfo.id;
      // this.editInfoStep1.name = this.editInfo.name;
      // this.editInfoStep1.principals = this.editInfo.principals;
      // this.editInfoStep1.phone = this.editInfo.phone;
      this.$refs.step1.info = this.editInfo;
      this.$nextTick(()=>{
        this.$refs.step1.init(this.editInfo);
      })
      for (let i = 0; i < this.loadList1.length; i++) {
        this.editInfo.applyFiles.map((item1) => {
          if (this.loadList1[i].id == item1.fileType) {
            let newItem = {};
            let newApplyFiles = {};
            newApplyFiles.filePath = item1.filePath;
            newApplyFiles.fileType = item1.fileType;
            newItem.uid = item1.id;
            let newName = item1.filePath.slice(
              item1.filePath.lastIndexOf("/") + 1
            );
            let firstname = newName.slice(0, newName.lastIndexOf("_"));
            let lastname = newName.slice(newName.lastIndexOf("."));
            newItem.name = firstname + lastname;
            newItem.name1 = newName;
            newItem.url = pieviewURL + newName;
            newItem.fileType = item1.fileType;
            this.loadList1[i].fileList.push(newItem);
            this.oldApplyFiles1.push(newApplyFiles);
          }
        });
      }
      for (let i = 0; i < this.loadList2.length; i++) {
        this.editInfo.applyFiles.map((item1) => {
          if (this.loadList2[i].id == item1.fileType) {
            let newItem = {};
            let newApplyFiles = {};
            newApplyFiles.filePath = item1.filePath;
            newApplyFiles.fileType = item1.fileType;
            newItem.uid = item1.id;
            let newName = item1.filePath.slice(
              item1.filePath.lastIndexOf("/") + 1
            );
            let firstname = newName.slice(0, newName.lastIndexOf("_"));
            let lastname = newName.slice(newName.lastIndexOf("."));
            newItem.name = firstname + lastname;
            newItem.name1 = newName;
            newItem.url = pieviewURL + newName;
            newItem.fileType = item1.fileType;
            this.loadList2[i].fileList.push(newItem);
            this.oldApplyFiles2.push(newApplyFiles);
            // this.oldApplyFiles2,'this.oldApplyFiles2')
            // this.oldApplyFiles2
          }
        });
      }
      for (let i = 0; i < this.loadList3.length; i++) {
        this.editInfo.applyFiles.map((item1) => {
          if (this.loadList3[i].id == item1.fileType) {
            let newItem = {};
            let newApplyFiles = {};
            newApplyFiles.filePath = item1.filePath;
            newApplyFiles.fileType = item1.fileType;
            newItem.uid = item1.id;
            let newName = item1.filePath.slice(
              item1.filePath.lastIndexOf("/") + 1
            );
            let firstname = newName.slice(0, newName.lastIndexOf("_"));
            let lastname = newName.slice(newName.lastIndexOf("."));
            newItem.name = firstname + lastname;
            newItem.name1 = newName;
            newItem.url = pieviewURL + newName;
            newItem.fileType = item1.fileType;
            this.loadList3[i].fileList.push(newItem);
            this.oldApplyFiles3.push(newApplyFiles);
          }
        });
      }
      for (let i = 0; i < this.loadList4.length; i++) {
        this.editInfo.applyFiles.map((item1) => {
          if (this.loadList4[i].id == item1.fileType) {
            let newItem = {};
            let newApplyFiles = {};
            newApplyFiles.filePath = item1.filePath;
            newApplyFiles.fileType = item1.fileType;
            newItem.uid = item1.id;
            let newName = item1.filePath.slice(
              item1.filePath.lastIndexOf("/") + 1
            );
            let firstname = newName.slice(0, newName.lastIndexOf("_"));
            let lastname = newName.slice(newName.lastIndexOf("."));
            newItem.name = firstname + lastname;
            newItem.name1 = newName;
            newItem.url = pieviewURL + newName;
            newItem.fileType = item1.fileType;
            this.loadList4[i].fileList.push(newItem);
            this.oldApplyFiles4.push(newApplyFiles);
          }
        });
      }
    }
  },
  methods: {
    goStep(item) {
      this.showIndex = 2;
      this.step1 = item;
    },
    uploadInfo(info) {
      this.loadList1 = info;
    },
    //上传文件更新
    upDataFile(fileItem, index, type) {
      if (type === 1) {
        let newItem = {};
        newItem.fileType = fileItem.fileType;
        let newName = fileItem.filePath.slice(
          fileItem.filePath.lastIndexOf("/") + 1
        );
        let firstname = newName.slice(0, newName.lastIndexOf("_"));
        let lastname = newName.slice(newName.lastIndexOf("."));
        newItem.name = firstname + lastname;
        newItem.name1 = newName;
        newItem.url = pieviewURL + newName;
        newItem.uid = fileItem.uid;
        this.loadList1[index].fileList.push(newItem);
      } 
      if(type === 2){
        let newItem = {};
        newItem.fileType = fileItem.fileType;
        let newName = fileItem.filePath.slice(
          fileItem.filePath.lastIndexOf("/") + 1
        );
        let firstname = newName.slice(0, newName.lastIndexOf("_"));
        let lastname = newName.slice(newName.lastIndexOf("."));
        newItem.name = firstname + lastname;
        newItem.name1 = newName;
        newItem.url = pieviewURL + newName;
        newItem.uid = fileItem.uid;
        this.loadList2[index].fileList.push(newItem);
        // console.log(this.loadList2,'loadList2')
      }
      if(type === 3){
        let newItem = {};
        newItem.fileType = fileItem.fileType;
        let newName = fileItem.filePath.slice(
          fileItem.filePath.lastIndexOf("/") + 1
        );
        let firstname = newName.slice(0, newName.lastIndexOf("_"));
        let lastname = newName.slice(newName.lastIndexOf("."));
        newItem.name = firstname + lastname;
        newItem.name1 = newName;
        newItem.url = pieviewURL + newName;
        newItem.uid = fileItem.uid;
        this.loadList3[index].fileList.push(newItem);
      }
      if(type === 4){
        let newItem = {};
        newItem.fileType = fileItem.fileType;
        let newName = fileItem.filePath.slice(
          fileItem.filePath.lastIndexOf("/") + 1
        );
        let firstname = newName.slice(0, newName.lastIndexOf("_"));
        let lastname = newName.slice(newName.lastIndexOf("."));
        newItem.name = firstname + lastname;
        newItem.name1 = newName;
        newItem.url = pieviewURL + newName;
        newItem.uid = fileItem.uid;
        this.loadList4[index].fileList.push(newItem);
      }
    },
    upStep(stepTwoList2, stepTwoList3) {
      this.showIndex = 1;
      this.step2 = stepTwoList3;
      this.oldApplyFiles1 = stepTwoList3;
      this.loadList1 = stepTwoList2;
    },
    downStep(stepTwoList, stepTwoList2) {
      this.showIndex = 3;
      this.step2 = stepTwoList2;
      this.oldApplyFiles1 = stepTwoList2;
      this.loadList1 = stepTwoList;
      // console.log(this.editInfo,'this.editInfo')
      if(this.editInfo !== null){
        this.$nextTick(()=>{
          this.$refs.step3.init(this.editInfo);
        })
      }else{
        this.$nextTick(()=>{
          this.$refs.step3.info.teacher1 = this.teacher1;
          this.$refs.step3.info.phone1 = this.phone1;
        })
      }
      // console.log(this.step2,'2 到 3')
    },
    upStep2(stepTwoList3, stepTwoList4,info1) {
      this.showIndex = 2;
      this.step3 = stepTwoList4;
      this.oldApplyFiles2 = stepTwoList4;
      this.loadList2 = stepTwoList3;
      this.teacher1 = info1.teacher1;
      this.phone1 = info1.phone1;
      // console.log(info1,'3 回 2')
    },
    downStep2(stepTwoList, stepTwoList3,info1){
      this.showIndex = 4;
      // this.$nextTick(()=>{
      //   this.$refs.step4.init(this.editInfo);
      // })
      this.step3 = stepTwoList3;
      this.oldApplyFiles2 = stepTwoList3;
      this.loadList2 = stepTwoList;
      this.teacher1 = info1.teacher1;
      this.phone1 = info1.phone1;
      if(this.editInfo !== null){
        this.$nextTick(()=>{
          this.$refs.step4.init(this.editInfo);
        })
      }else{
        this.$nextTick(()=>{
          this.$refs.step4.info.teacher2 = this.teacher2;
          this.$refs.step4.info.phone2 = this.phone2;
        })
      }
      // console.log('3到4')
    },
    upStep3(stepTwoList4, stepTwoList5) {
      this.showIndex = 3;
      // this.$nextTick(()=>{
      //   this.$refs.step3.init(this.editInfo);
      // })
      this.step4 = stepTwoList5;
      this.oldApplyFiles3 = stepTwoList5;
      this.loadList3 = stepTwoList4;
      this.$nextTick(()=>{
        this.$refs.step3.info.teacher1 = this.teacher1;
        this.$refs.step3.info.phone1 = this.phone1;
      })
      // console.log(this.teacher1,'4到3')
    },
    downStep3(stepTwoList, stepTwoList4,info2){
      this.showIndex = 5;
      // this.$nextTick(()=>{
      //   this.$refs.step5.init(this.editInfo);
      // })
      this.step4 = stepTwoList4;
      // console.log(this.step4,'step4')
      this.oldApplyFiles3 = stepTwoList4;
      this.loadList3 = stepTwoList;
      this.teacher2 = info2.teacher2;
      this.phone2 = info2.phone2;
      if(this.editInfo !== null){
        this.$nextTick(()=>{
          this.$refs.step5.init(this.editInfo);
        })
      }else{
        this.$nextTick(()=>{
          this.$refs.step5.info.teacher3 = this.teacher3;
          this.$refs.step5.info.phone3 = this.phone3;
        })
      }
      // console.log(info2,'4到5')
    },
    upStep4(stepTwoList5, stepTwoList6,info3) {
      this.showIndex = 4;
      // this.$nextTick(()=>{
      //   this.$refs.step4.init(this.editInfo);
      // })
      this.step5 = stepTwoList6;
      this.oldApplyFiles4 = stepTwoList6;
      this.loadList4 = stepTwoList5;
      this.teacher3 = info3.teacher3;
      this.phone3 = info3.phone3;
      this.$nextTick(()=>{
        this.$refs.step4.info.teacher2 = this.teacher2;
        this.$refs.step4.info.phone2 = this.phone2;
      })
      // console.log(info3,'5回4')
    },
    deleteFile(file) {
      deleteFile({
        filePath: `linxuan/${file.name1}`,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
        }
      });
      this.oldApplyFiles1 = this.oldApplyFiles1.filter((item) => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
    },
    deleteFile2(file) {
      deleteFile({
        filePath: `linxuan/${file.name1}`,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
        }
      });
      this.oldApplyFiles2 = this.oldApplyFiles2.filter((item) => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
    },
    deleteFile3(file) {
      deleteFile({
        filePath: `linxuan/${file.name1}`,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
        }
      });
      this.oldApplyFiles3 = this.oldApplyFiles3.filter((item) => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
    },
    deleteFile4(file) {
      deleteFile({
        filePath: `linxuan/${file.name1}`,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
        }
      });
      this.oldApplyFiles4 = this.oldApplyFiles4.filter((item) => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
    },
    
    submit(List, applyFiles5,info3) {
      // console.log(this.step3,"this.step3")
      // console.log(this.step4,"this.step4")
      // console.log(this.step5,"this.step5")
      let data = {};
      this.spinning = true
      this.step5 = applyFiles5;
      // console.log(this.step5,'step5')
      let applyFiles = this.step2.concat(this.step3,this.step4,this.step5);
      // console.log(applyFiles,'total')
      data.applyFiles = applyFiles;
      data.name = this.step1.name;
      data.phone = this.step1.phone;
      data.principals = this.step1.principals;
      data.teams = this.step1.teams;
      data.levelType = this.step1.levelType;
      data.teamType = this.step1.teamType;
      data.schoolName = this.$store.state.user.realname;
      data.teacher1 = this.teacher1;
      data.phone1 = this.phone1;
      data.teacher2 = this.teacher2;
      data.phone2 = this.phone2;
      data.teacher3 = info3.teacher3;
      data.phone3 = info3.phone3;
      let routerPath = "";
      if (this.$route.name === "szStudioDataUpload") {
        data.applyType = 1;
        routerPath = "szStudio";
      } else if (this.$route.name === "educationalBrandDataUpload") {
        data.applyType = 2;
        routerPath = "educationalBrand";
      } else {
        data.applyType = 3;
        routerPath = "szMicroClass";
      }
      if (this.id !== null) {
        data.id = this.id;
      }
      // console.log(data,'data')
      this.addLxApplySaveOrUpdate(data, routerPath);
    },
    addLxApplySaveOrUpdate(data, routerPath) {
      lxApplySaveOrUpdate(data).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.spinning = false
          this.$router.push({ name: routerPath });
          window.sessionStorage.removeItem(`step${this.$store.state.user.id}`);
        } else {
          this.$message.error(res.message);
          this.spinning = false
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.info-up-box {
  width: 100%;
  height: 100%;
  // max-height: 635px;
  overflow-y: auto;
  padding: 15px 30px;
  background: #ffffff;
  border-radius: 10px;
}
.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 14px;
  margin-bottom: 15px;
}
.mb30 {
  margin-bottom: 20px;
}
.fw600 {
  font-weight: 600;
}
.img-box {
  width: 50px;
  height: 50px;
  cursor: pointer;
  margin-bottom: 16px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.img-box-3 {
  width: 241px;
  height: 203px;
  margin: 50px auto;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.step-box {
  padding-bottom: 10px;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  line-height: 38px;
  text-align: center;
  background: #c73630;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
</style>
